import React from 'react'
import './LogisticsHero.scss'

export class LogisticsHero extends React.Component {
  render() {
    return (
      <div
        className="logistics-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>Logistics Modernization</h1>
            <h2>AI-Powered Systems for Fleet Readiness and Supply Chain Excellence</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default LogisticsHero
